import http from '@/plugins/axios_plugin';

class ServiceNotificacoes {
    index () {
        return http.get('/api/notificacoes/listar')
    }

    responder (notificacao_id, resposta) {
        return http.post('/api/notificacoes/' + notificacao_id + '/responder', { resposta: resposta })
    }
}

export default new ServiceNotificacoes();